import appmaker from '@appmaker/core/index';
import BackInStockHeader from './BackInStockHeader';

// DetailHeader renders the override via `${extension.id}-override-header-component-installed`.
// Extension handle is `back-in-stock-by-appmaker`; the filter key below matches it.
const BackInStock = {
    id: 'back-in-stock-by-appmaker',
    name: 'Back in Stock by Appmaker',
    activate: () => {
        appmaker.addFilter(
            'back-in-stock-by-appmaker-override-header-component-installed',
            'extension-override',
            (override, meta) => (
                <BackInStockHeader override={override} meta={meta} />
            )
        );
    },
};

export default BackInStock;
